// @flow

import * as React from 'react';
import { observer } from 'mobx-react';
import { Table } from 'reactstrap';
import Analyse from '../../Model/Analyse';
import AnalyseTableRow from './AnalyseTableRow';

type Props = {
  analysis: Array<Analyse>,
  onClick: (analyse: Analyse) => void,
};

@observer
export default class AnalyseTable extends React.Component<Props, void> {
  render() {
    const { analysis, onClick } = this.props;

    return (
      <Table hover striped size="sm">
        <thead>
          <tr>
            <th>Name</th>
          </tr>
        </thead>
        <tbody>
          {analysis.map((a: Analyse, i: number) => (
            <AnalyseTableRow analysis={a} key={a.id} onClick={onClick} />
          ))}
        </tbody>
      </Table>
    );
  }
}



// WEBPACK FOOTER //
// ./src/App/Views/Analysis/AnalyseTable.js